import { useEffect } from 'react';
import { io } from 'socket.io-client';

function NotificationsListener() {
    useEffect(() => {
        // Forcer l'utilisation de cooptaleo.com (sans www) pour éviter les redirections 301
        const socketUrl = process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_FRONTEND_BASE_URL || "https://cooptaleo.com";
        // S'assurer qu'on n'utilise jamais www
        const cleanUrl = socketUrl.replace('www.', '').replace(/\/$/, '');
        const socket = io(`${cleanUrl}/`, {
            transports: ['polling', 'websocket'],
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000
        });
        const currentUserId = localStorage.getItem('userId');

        socket.on("connect", () => {
            socket.emit("register", currentUserId);
        });

        socket.on("notification", ({ title, message }) => {
            if (Notification.permission === "granted") {
                new Notification(title, { body: message });
            } else if (Notification.permission !== "denied") {
                Notification.requestPermission().then((permission) => {
                    if (permission === "granted") {
                        new Notification(title, { body: message });
                    }
                });
            }
        });

        return () => socket.disconnect();
    }, []);

    return null;
}

export default NotificationsListener;
